import React, {PureComponent} from 'react';
import {Card, CardContent, Typography} from '@mui/material';
import CardHeader from "@mui/material/CardHeader";
import CardActionArea from "@mui/material/CardActionArea";
import {withRouter} from "../../../hooks/withRouter";
import Collapse from "@mui/material/Collapse";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import {UserLocalStorage} from "../../../core/storage/UserLocalStorage";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import GoalCard from "../../routine/partials/Goals/GoalCard";
import {MicroInsightUtils} from "../../../core/insights/MicroInsightUtils";

class GoalStatsCard extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			goals: UserLocalStorage.get(UrlBuilder.goals.exerciseGoalsApi(null, null, true)) ?? null,
			isCollapseOpen: false,
			isLoading: false,
			hasLoadedAtLeastOnce: false,
		};
	}

	hasNeverBeenFetched = () => {
		return this.state.goals === null;
	}

	fetch = async () => {
		this.setState({ isLoading: true });

		const response = await fetch(UrlBuilder.goals.exerciseGoalsApi(null, null, true));

		if (response.status !== 200) {
			this.setState({ isLoading: false });
			return;
		}

		const responseData = await response.json();

		this.setState({
			goals: responseData['data'] ?? [],
			isLoading: false,
			hasLoadedAtLeastOnce: true,
		});

		UserLocalStorage.set(UrlBuilder.goals.exerciseGoalsApi(null, null, true), responseData['data'] ?? []);
	}

	triggerCollapse = () => {
		this.setState({ isCollapseOpen: !this.state.isCollapseOpen });

		if (!this.state.isCollapseOpen && !this.state.hasLoadedAtLeastOnce) {
			this.fetch();
		}
	}

	renderGoalCards = () => {
		if (this.hasNeverBeenFetched()) {
			return this.renderLoadingSkeleton();
		}

		if (this.state.goals.length === 0) {
			return (
				<Box sx={{ textAlign: 'center', py: 3 }}>
					<TrackChangesIcon sx={{ fontSize: 36, color: 'text.disabled', mb: 1 }} />
					<Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
						No goals yet
					</Typography>
					<Typography variant="caption" sx={{ color: 'text.disabled' }}>
						Create goals from your routine exercises to track progress.
					</Typography>
				</Box>
			);
		}

		return (
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
				{this.state.goals.map(goal => (
					<GoalCard key={goal.id} goal={goal} />
				))}
			</Box>
		);
	}

	renderLoadingSkeleton = () => (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
			{[1, 2].map(i => (
				<Skeleton key={i} variant="rounded" height={90} sx={{ borderRadius: 2 }} />
			))}
		</Box>
	)

	render() {
		const insightText = this.state.goals ? MicroInsightUtils.getGoalInsight(this.state.goals) : null;

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardActionArea onClick={this.triggerCollapse}>
					<CardHeader
						sx={{ py: 1.25 }}
						avatar={<EmojiEventsIcon sx={{ color: 'text.secondary', fontSize: 22 }} />}
						title={
							<Typography variant="h5" sx={{ fontSize: 21 }}>
								Goals
							</Typography>
						}
						subheader={insightText ? (
							<Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'secondary.main', mt: 0.25 }}>
								<AutoAwesomeIcon sx={{ fontSize: 14 }} /> {insightText}
							</Typography>
						) : null}
						action={
							<IconButton size="small">
								{this.state.isCollapseOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
							</IconButton>
						}
					/>
				</CardActionArea>
				<Collapse in={this.state.isLoading}>
					<LinearProgress color="secondary" />
				</Collapse>

				<Collapse in={this.state.isCollapseOpen}>
					<CardContent sx={{ pt: 1 }}>
						{this.renderGoalCards()}
					</CardContent>
				</Collapse>
			</Card>
		);
	}
}

export default withRouter(GoalStatsCard);